export default "__VITE_ASSET__CW0wvGkJ__"